import React from "react";
import { Layout, Typography } from "antd";
const { Title, Paragraph, Text, Link } = Typography;

function Footer() {
  return (
    <Layout.Footer style={{ textAlign: "center" }}>
      <Typography>
        <Paragraph>
          <Text type="secondary">Desarrollado por Qualiforge</Text>
        </Paragraph>
      </Typography>
    </Layout.Footer>
  );
}

export default Footer;
